<template>
  <!-- 管理员页面 -->
  <div>
    <!-- 1.面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        系统管理
      </el-breadcrumb-item>
      <el-breadcrumb-item>操作历史查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 2.搜索框 -->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输查询信息（用空格分隔），支持模糊搜索" v-model="query">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryUser()"></el-button>
          </el-input>

        </el-col>
      </el-row>
      <!-- 3.表格 -->
      <el-table :data="users" style="width: 100%; margin-top: 20px;">

        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="userid" label="id" width="100"></el-table-column>
        <el-table-column prop="username" label="姓名" width="80"></el-table-column>
        <!-- <el-table-column prop="organization" label="单位" width="280"></el-table-column> -->
        <!-- <el-table-column prop="tel" label="电话" width="180"></el-table-column> -->
        <!-- <el-table-column prop="email" label="邮箱" width="180"></el-table-column> -->
        <!-- <el-table-column prop="addr" label="地址" width="180"></el-table-column> -->
        <el-table-column label="操作时间" width="120">
          <template slot-scope="scope">{{
            scope.row.op_time | fmtdate
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="is_active" label="用户状态" width="90">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_active" active-color="#13ce66" inactive-color="#ff4949"
              @change="userIsActive(scope.row)"></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop="op_type" label="操作" width="150"> </el-table-column>
        <el-table-column prop="op_result" label="操作结果" width="150"> </el-table-column>
        <el-table-column prop="op_details" label="详情" width="350"> </el-table-column>
      </el-table>
      <!-- 4.分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

    </el-card>
  </div>
</template>

<script>
  import fileDownload from 'js-file-download'

  // pdf预览
  import pdf from 'vue-pdf'

  export default {
    components: {
      pdf
    },
    data() {
      return {
        // 查看图片
        picSrc: '',
        picVisible: false,
        //pdf查看
        pdfSrc: '', //后台传输pdf文件
        pdfVisible: false,
        pageNum: 1,
        pageTotalNum: 1,
        // 加载进度
        loadedRatio: 0,
        curPageNum: 0,
        goPageNum: 1,

        query: "", //查询信息
        users: [],
        //分页
        currentPage: 1,
        page_size: 10,
        total: 0,
        //添加用户 对话框属性
        addUserFormVisible: false,
        // 修改用户 对话框属性
        editUserFormVisible: false,
        // 查看用户 对话框熟悉
        userInfoFormVisible: false,
        // 职称文件列表
        fileList: [],
        formLabelWidth: "",


      }
    },
    created() {
      this.getUsers(1, 10)
      //请求携带token
      // this.axios.defaults.headers['token'] = localStorage.getItem('token')
    },
    methods: {
      //获取用户列表
      async getUsers(page, page_size) {
        const res = await this.axios.get(
          `/opLog/?page=${page}&page_size=${page_size}`
        )
        if (res.status === 200) {
          this.users = res.data.results
          this.total = res.data.count
          // console.log(res)
        } else {
          this.$message.warning("错误")
        }
      },
      //分页
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.page_size = val
        this.getUsers(this.currentPage, this.page_size)
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getUsers(this.currentPage, this.page_size)
      },

      // 查询用户
      async queryUser() {
        const res = await this.axios.get(
          `/opLog/?page=${this.currentPage}&page_size=${this.page_size}&search=${this.query}`
        )
        if (res.status === 200) {
          this.users = res.data.results
          this.total = res.data.count
          // console.log(res)
        } else {
          this.$message.warning("错误")
        }
      },

    },
  }

</script>

<style lang="less" scoped>
  .el-card {
    height: 100%;
    margin-top: 15px;
  }

  .row-search {
    margin-top: 20px;
  }

  .user-search {
    width: 420px;
  }

  .el-pagination {
    margin-top: 15px;
  }

  .el-col-user-add {
    display: flex;
  }

  .bt-user-add {
    margin-left: 10px;
  }

  .div-file {
    margin-top: 15px;

    .div-upload {
      height: 47px;

      .input-upload {
        width: 73px;
        height: 33px;
        position: absolute;
        z-index: 1;
        opacity: 0;
      }

      .button-upload {
        position: absolute;
      }

      .button-upload:hover {
        cursor: pointer;
      }
    }
  }

  .demo-table-expand {
    font-size: 0;

    label {
      width: 90px;
      color: #99a9bf;
    }

    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/Log.vue